import { render, staticRenderFns } from "./import-substitution-request-show-ktru-item-block.vue?vue&type=template&id=d5a7ed38&scoped=true&"
import script from "./import-substitution-request-show-ktru-item-block.vue?vue&type=script&lang=js&"
export * from "./import-substitution-request-show-ktru-item-block.vue?vue&type=script&lang=js&"
import style0 from "./import-substitution-request-show-ktru-item-block.vue?vue&type=style&index=0&id=d5a7ed38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a7ed38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5a7ed38')) {
      api.createRecord('d5a7ed38', component.options)
    } else {
      api.reload('d5a7ed38', component.options)
    }
    module.hot.accept("./import-substitution-request-show-ktru-item-block.vue?vue&type=template&id=d5a7ed38&scoped=true&", function () {
      api.rerender('d5a7ed38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/import-substitution/import-substitution-request-show-ktru-item-block.vue"
export default component.exports